/**
 * Created on 2017/2/19.
 */
define('controllers/myaccount/balance/account-mainbalance.ctrl',['app', 'mainCons', 'viewer'], function (app, mainCons, imgViewer) {
    app.controller('AccountMainBalanceCtrl', ['$q', '$scope', '$rootScope', '$state', '$stateParams', '$filter', 'OpenOther',
        'AppPromote', 'InAppNew', 'OpenUp', 'auiDialog', 'ngDialog', 'UserInfo', 'UserInfoPreload', 'auiBalanceService',
        'invoiceService', 'auiAgreementHelper', 'OpenTrade', 'payService', 'auiTeamAccountService', 'auiUpload',
        function ($q, $scope, $rootScope, $state, $stateParams, $filter, OpenOther,
                  AppPromote, InAppNew, OpenUp, auiDialog, ngDialog, UserInfo, UserInfoPreload, auiBalanceService,
                  invoiceService, auiAgreementHelper, OpenTrade, payService, auiTeamAccountService, auiUpload) {
            /* 1. 局部变量声明 */
            /* 2. $scope变量声明 */
            /* 3. $scope函数挂载 */
            var signParty = $stateParams.signParty;

            $state.go('balance', {signParty: signParty});
            return;//后面下面废弃吧
            var contractUs = window.sysUrlCfg.documentHref.contractUs;

            var agreementNames = mainCons.balanceConstant.agreementNames;
            var Model = $scope.Model = {
                clickRepeat: 0,
                selectedTab: signParty,
                showYXQTab: false,
                isMemberAccount: AUI.HDGWCall.getUserInfoValue('teamid')
            };
            //如果是子帐号重新获取法务
            if (AUI.HDGWCall.getUserInfoValue('teamid')) {
                UserInfo.getUserRouteInfo(true).then(function (data) {
                    //判断是否是法务
                    Model.isLegal = data.isLegal;
                });
            }

            function init() {
                //页面进入需要查询接口，非页面进入直接使用页面进入时的值
                if ($scope.$parent.Model.eventSource == 'page') {
                    setYXQshow();
                    $state.go('MyAccount.mainbalance.bill', {signParty: signParty});
                } else {
                    Model.showYXQTab = $scope.$parent.Model.showYXQTab;
                }
            }

            init();

            Model.userType = UserInfoPreload.userType;
            Model.isTeamId = AUI.HDGWCall.getUserInfoValue('teamid');

            function setYXQshow() {
                var queryBalanceReq = {
                    version: '1.0',
                    signPartys: [0, 1, 2, 4],
                    traceUniqueID: auiBalanceService.getTraceUniqueID()
                };
                OpenTrade.getBalance({req: queryBalanceReq}, true).then(function (data) {
                    if (!data.accountInfos || data.accountInfos.length == 0) {
                        Model.showYXQTab = false;
                        $scope.$parent.Model.showYXQTab = false;
                    } else {
                        Model.showYXQTab = true;
                        $scope.$parent.Model.showYXQTab = true;
                    }
                });
            }


            /* 切换Tab触发的方法 */
            $scope.changeTabType = function (type) {
                $scope.$parent.Model.eventSource = 'AccountMainBalanceCtrl.changeTabType';
                if (Model.selectedTab != type) {
                    Model.selectedTab = type;
                    $state.go('MyAccount.mainbalance.bill', {signParty: type});
                }
            };

            //推广基金充值提示页面
            $scope.goFund = function () {
                Model.clickRepeat++
                if (Model.clickRepeat > 1) {
                    return
                }
                var defer = $q.defer();
                // 查询是否签署过最新支付协议  排除法务
                if (AUI.HDGWCall.getUserInfoValue('teamid') && !$scope.isLegal) {
                    IsSignTwoAgreement().then(function (data) {
                        Model.clickRepeat = 0
                        if (!Model["1010"]) {
                            // 查询是否签署过最新支付协议
                            auiAgreementHelper.checkAgreement('1010', function () {
                            }, UserInfoPreload).then(function (data) {
                            });
                        } else {
                            goFundDialog();
                        }
                        defer.reject();
                    }).catch(function () {
                        Model.clickRepeat = 0
                    });
                } else {
                    goFundDialog();
                    defer.reject();
                }
                return defer.promise;
            }

            //判断是否签署过付费协议
            function IsSignTwoAgreement() {
                var defer = $q.defer();
                auiAgreementHelper.queryAgreements(['1010']).then(function (signInfo) {
                    if (signInfo && signInfo.signInfoList && signInfo.signInfoList.length > 0) {
                        signInfo.signInfoList.forEach(function (signedText) {
                            if (signedText.signStatus == 1 || (signedText.signStatus == 2 && signedText.isForcedSign != 'true')) {// 签署状态。1：已签署最新版本；2：已签署非最新版本；3：未签署；
                                Model[signedText.agrType] = true;
                            } else {
                                Model[signedText.agrType] = false;
                            }
                        });
                        defer.resolve(Model);
                    } else {
                        defer.resolve(Model);
                        auiDialog.failSystemError();
                    }
                });
                return defer.promise;
            }


            function goFundDialog() {
                //校验实名认证的状态
                if (auiBalanceService.validateRealState()) {
                    Model.clickRepeat = 0
                    auiDialog.fail("实名资料变更审核中或审核未通过，不允许充值");
                    return;
                }
                //检查是否签署支付协议，如果没有签署，则跳转到签署页面
                payService.isPayable().then(function (payable) {
                    Model.clickRepeat = 0
                    var tipmsg = '您的付费服务还未开通或者正在申请中，请您开通付费服务后再使用现金账户充值服务，如有疑问，请<a class="text-link" target="_blank" href="' + contractUs + '">联系我们</a>。';
                    if (payable) {
                        fund();
                    } else {
                        auiDialog.warn('充值提示', tipmsg, function () {
                            //设置标识，表明是从我的账户跳转过去的
                            $rootScope.isBlance = true;
                            $rootScope.showPayServ();
                        });
                    }
                }).catch(function () {
                    Model.clickRepeat = 0
                });
            }

            function fund() {
                var ngd = ngDialog.open({
                    template: 'pages/myaccount/balance/balance.fund.add.html',
                    className: '',
                    closeByEscape: false,
                    closeByDocument: false,
                    overlay: false,
                    controller: ['$scope', function ($scope) {
                        $scope.isMemberAccount = Model.isMemberAccount;
                        $scope.isSignHW = Model['1010'];
                        $scope.isLegal = Model.isLegal;
                        $scope.isSignAspiegal = Model['1010'];
                        $scope.contentAccount = "中国大陆推广账户余额与海外推广账户余额不能互转" + (($scope.isMemberAccount && !$scope.isLegal) && (!$scope.isSignHW || !$scope.isSignAspiegal) ? "<p>如您不能充值，请联系帐号持有者（联系人邮箱：" + UserInfo.get().contactEmail + "）或者有法务角色的成员帐号签署相关付费协议。</p>" : "");
                        if (Model.isMemberAccount) {
                            if (Model['1010']) {
                                $scope.signParty = 0;
                            } else {
                                $scope.signParty = 1;
                            }
                        } else {
                            $scope.signParty = 0;
                        }
                        $scope.agreemIsSelected = false;
                        $scope.showSignAgreeSign = false;
                        var agreemenTypes = {0: 1010, 1: 1010};
                        var agreementVersions = {};
                        var tempUrl = '';
                        $scope.agreementName = agreementNames[$scope.signParty];
                        $scope.userType = Model.userType;

                        $scope.toFund = function () {
                            if ($scope.showSignAgreeSign && !$scope.agreemIsSelected) {
                                return;
                            }
                            signParty = $scope.signParty;
                            if ($scope.showSignAgreeSign && $scope.agreemIsSelected) {
                                auiAgreementHelper.signAgreement({
                                    agrType: agreemenTypes[signParty],
                                    version: agreementVersions[signParty],
                                    language: $scope.templateInfo.language
                                }).then(function (signAgreementResult) {
                                    if (signAgreementResult) {
                                        toRecharge();
                                    } else {
                                        auiDialog.fail('付费服务签署失败，请联系客服');
                                    }
                                });
                            } else {
                                toRecharge();
                            }

                            function toRecharge() {
                                var recharge = ngDialog.open({
                                    template: 'pages/myaccount/balance/balance.recharge.html',
                                    className: '',
                                    closeByEscape: false,
                                    closeByDocument: false,
                                    overlay: false,
                                    scope: $rootScope,
                                    controller: ['$scope', function ($scope) {
                                        $rootScope.isRefreshReceipt = false;
                                        //默认选中通用基金
                                        $scope.chargeType = 30;
                                        var modelDia = $scope.modelDia = {};
                                        //默认选中线上支付
                                        $scope.purchaseType = 0;
                                        $scope.money = 0;
                                        $scope.isMoneyValid = true;
                                        $scope.developerName = UserInfo.get().loginName;
                                        $scope.userType = UserInfo.get().userType;
                                        modelDia.signPartyType = angular.copy(signParty);
                                        $scope.signParty = signParty;
                                        $scope.setChargeType = setChargeType;
                                        $scope.changeCountry = changeCountry;
                                        $scope.delimg = delimg;
                                        modelDia.downAgentAttachmentTemplate = systemParaConf.downAgentAttachmentTemplate;
                                        if ($scope.signParty == 1) {
                                            $scope.purchaseType = 1;
                                        }
                                        modelDia.agentFlag = '1';
                                        refreshReceipt();
                                        //初始化实名认证的国家列表
                                        auiTeamAccountService.getRealNameCountryList().then(function (data) {
                                            modelDia.countrys = data.allContrysFromInterface;
                                            modelDia.agentCountryObj = modelDia.countrys.find(function (country) {
                                                return country.country === "CN";
                                            })
                                        });

                                        modelDia.uploadAgentAttach = function (files, options, item) {
                                            auiUpload.uploadOpenTrade(files, '1', options).then(function (fileUrl) {
                                                if (files && files.length > 0) {
                                                    modelDia.agreementAttachmentsName = files[0].name
                                                }
                                                modelDia.agentAttachment = fileUrl;
                                            });
                                        };


                                        //更新国家
                                        function changeCountry(country) {
                                            modelDia.agentCountryObj = country;
                                        }

                                        //删除附件
                                        function delimg() {
                                            modelDia.agentAttachment = '';
                                        }

                                        //刷新发票信息
                                        function refreshReceipt() {
                                            OpenUp.getReceiptInfo({req: {}}).then(function (data) {
                                                if (data && data.resultCode == 0) {
                                                    $scope.title = data.receipt.title;
                                                }
                                            });
                                        }

                                        function setChargeType(chargeType) {
                                            $scope.chargeType = chargeType;
                                        }

                                        $scope.close = close;

                                        function close() {
                                            recharge.close();
                                        }

                                        $scope.moneyKeyup = function () {
                                            $scope.isMoneyValid = auiBalanceService.validateMoney($scope.money);
                                        };
                                        $scope.goPay = function () {
                                            if ($scope.userType == 1 && $scope.chargeType == 29) {
                                                auiDialog.fail("云文件夹推广不支持个人用户");
                                                return;
                                            }
                                            if (!auiBalanceService.validateMoney($scope.money)) {
                                                $scope.isMoneyValid = false;
                                                return;
                                            }
                                            if ($scope.userType != 1 && (modelDia.signPartyType == 1 || modelDia.signPartyType == 4) && modelDia.agentFlag == '0') {
                                                $scope.rechargeForm.agentAttachment.$setDirty();
                                                $scope.rechargeForm.agentName.$setDirty();
                                            }
                                            if ($scope.rechargeForm.$invalid) {
                                                return;
                                            }
                                            var agent = {};
                                            if ($scope.userType != 1 && (modelDia.signPartyType == 1 || modelDia.signPartyType == 4) && modelDia.agentFlag == '0') {
                                                agent.agentFlag = 0;
                                                agent.agentName = modelDia.agentName;
                                                agent.agentCountry = modelDia.agentCountryObj.country;
                                                agent.agentAttachment = modelDia.agentAttachment;
                                            }
                                            var bool = auiBalanceService.goPay($scope.money, $scope.purchaseType, $scope.chargeType, modelDia.signPartyType, "", init, imgViewer, agent);
                                            if (bool == undefined) {
                                                recharge.close();
                                            }
                                        };

                                        $scope.modReceipt = function () {
                                            auiBalanceService.modReceipt($scope);
                                        };
                                        // 监控 $rootScope.refreshReceipt
                                        $scope.$watch("isRefreshReceipt", function (newValue, oldValue) {
                                            if (newValue) {
                                                refreshReceipt();
                                                $rootScope.isRefreshReceipt = false;
                                            }
                                        }, false);
                                    }]
                                });
                                ngd.close();
                            }
                        };

                        $scope.chooseAgree = function ($event) {
                            var checkbox = $event.target;
                            if (checkbox.checked) {
                                $scope.agreemIsSelected = true;
                            } else {
                                $scope.agreemIsSelected = false;
                            }
                        };

                        $scope.changeSignParty = function (signParty) {
                            if ((signParty == 0 && !$scope.isSignHW && $scope.isMemberAccount && !$scope.isLegal) || (signParty == 1 && !$scope.isSignAspiegal && $scope.isMemberAccount && !$scope.isLegal)) return;
                            $scope.signParty = signParty;
                            $scope.agreementName = agreementNames[signParty];
                            $scope.agreemIsSelected = false;
                            getIsSignAgreement();
                        };


                        init();

                        function init() {
                            getIsSignAgreement();
                        }

                        //判断是否签署过付费协议
                        function getIsSignAgreement() {
                            auiAgreementHelper.queryAgreements([agreemenTypes[$scope.signParty]]).then(function (signInfo) {
                                if (signInfo && signInfo.signInfoList && signInfo.signInfoList.length > 0) {
                                    var signedText = signInfo.signInfoList[0];
                                    agreementVersions[$scope.signParty] = signedText.latestVersion;
                                    if (signedText.signStatus == 1 || (signedText.signStatus == 2 && signedText.isForcedSign != 'true')) {// 签署状态。1：已签署最新版本；2：已签署非最新版本；3：未签署；
                                        $scope.showSignAgreeSign = false;
                                    } else {
                                        $scope.showSignAgreeSign = true;
                                    }
                                    queryAgreeTemplate(agreemenTypes[$scope.signParty], signedText.latestVersion).then(function (respUrl) {
                                        tempUrl = respUrl;
                                    });
                                } else {
                                    auiDialog.failSystemError();
                                }
                            });
                        }

                        function queryAgreeTemplate(agrType, latestVersion) {
                            var defer = $q.defer();
                            var respUrl;
                            auiAgreementHelper.agreementToTemplateInfo([{
                                agrType: agrType,
                                latestVersion: latestVersion
                            }]).then(function (templateInfoListResult) {
                                if (templateInfoListResult && templateInfoListResult.templateInfoList && templateInfoListResult.templateInfoList.length > 0) {
                                    var templateInfo = templateInfoListResult.templateInfoList[0];
                                    $scope.templateInfo = templateInfo;
                                    if (templateInfo) {
                                        respUrl = templateInfo.url;
                                    }
                                    defer.resolve(respUrl);
                                } else {
                                    defer.reject(respUrl);
                                }
                            });
                            return defer.promise;
                        }

                        $scope.showAgreement = function () {
                            // 根据最新的协议版本，查询协议平台，弹框提示签署
                            AUI.BaseJSUtil.redirectUrlByBlank(tempUrl);
                        };
                        $scope.close = function () {
                            ngd.close();
                        };
                    }]
                });
            }

            //推广基金余额提醒及设置页面
            $scope.reMind = function () {
                var ngd = ngDialog.open({
                    template: 'pages/myaccount/balance/balance.remind.html',
                    className: '',
                    closeByEscape: false,
                    closeByDocument: false,
                    overlay: false,
                    controller: ['$scope', function ($scope) {
                        $scope.userType = UserInfo.get().userType;
                        $scope.chargeType = 26;

                        $scope.isPhoneValid = true;
                        $scope.showPhoneValid = false;
                        $scope.verifiedPhoneSuccess = false;// 联系人手机已验证标识，0-待验证，1-不需要验证，2-已通过单独验证，提交修改时需要再验证
                        $scope.verCode = "";// 验证码
                        $scope.isEmailValid = true;
                        $scope.isBalanceValid = true;

                        changeChargeType($scope.chargeType);

                        $scope.changeChargeType = changeChargeType;

                        function changeChargeType(chargeType) {
                            $scope.chargeType = chargeType;
                            auiBalanceService.queryUserBalRemindInfo($scope);
                        }

                        $scope.setReMind = function () {
                            var defer = $q.defer();
                            checkPhone();
                            auiBalanceService.saveRemindInfo($scope).then(function () {
                                ngd.close();
                                defer.resolve();
                            }, function () {
                                defer.reject();
                            }).catch(function () {
                                ngd.close();
                                defer.reject();
                            });
                            return defer.promise;
                        };
                        //Email和手机号码，复选框选中后，文本框可用，不选则不可用
                        $scope.mailPhoneChecked = function (type, isCheck) {
                            if (type == 1) {
                                if (isCheck) {
                                    $scope.isMailDisabled = true;
                                    $scope.isEmaiChecked = false;
                                    $scope.isEmailValid = $scope.email ? auiBalanceService.validateEmail($scope.email) : true;
                                } else {
                                    $scope.isMailDisabled = false;
                                    $scope.isEmaiChecked = true;
                                }
                            } else if (type == 2) {
                                if (isCheck) {
                                    $scope.isMobilePhoneDisabled = true;
                                    $scope.isMobilePhoneChecked = false;
                                    $scope.isPhoneValid = $scope.mobilePhone ? auiBalanceService.validatePhone($scope.mobilePhone) : true;
                                } else {
                                    $scope.isMobilePhoneDisabled = false;
                                    $scope.isMobilePhoneChecked = true;
                                }
                            }
                        };
                        //校验手机号码
                        $scope.phoneKeyup = function () {
                            checkPhone();
                        };
                        $scope.emailKeyup = function () {
                            $scope.isEmailValid = auiBalanceService.validateEmail($scope.email);
                        };
                        $scope.balanceKeyup = function () {
                            $scope.isBalanceValid = auiBalanceService.validateBalance($scope.balanceRemind);
                        };
                        $scope.close = function () {
                            ngd.close();
                        }

                        function checkPhone() {
                            if ($scope.oldRemindPhone != $scope.mobilePhone) {
                                $scope.isPhoneValid = auiBalanceService.validatePhone($scope.mobilePhone);
                                $scope.showPhoneValid = $scope.isPhoneValid;
                                if ($scope.verifiedPhoneFlag == 1) {
                                    $scope.verifiedPhoneFlag = 0;
                                }
                            } else {
                                $scope.isPhoneValid = true;
                                $scope.showPhoneValid = false;
                                $scope.verifiedPhoneFlag = 1;
                            }
                        }
                    }]
                });
            }
        }])
});

